import { combine, withState, withCallbacks } from 'react-hooks-combine'

import BaseModalComponent from './component'

export const BaseModal = combine(
  withState('opened', 'open', false),
  withCallbacks(
    {
      onTrigger:
        ({ open }) =>
        () => {
          open(true)
        },

      onRequestClose:
        ({ open }) =>
        () => {
          open(false)
        },
    },
    []
  )
)(BaseModalComponent)
